// extracted by mini-css-extract-plugin
export default {"settings":"TPEMGhqnKf2qWzBWii1z","container":"gHPfi1iIICrg5wbHhc_h","body":"lqhCHRbg9Sn5jLKPu8aq"};